import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PortalNotification } from 'src/app/core/domain/portal-notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  private readonly base = `${environment.apiUrl}/notifications`;

  /** Live unread count. Components can subscribe to this. */
  readonly unreadCount$ = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient) {}

  getAll(): Observable<PortalNotification[]> {
    return this.http.get<PortalNotification[]>(this.base);
  }

  refreshUnreadCount(): void {
    this.http
      .get<{ count: number }>(`${this.base}/unread`)
      .subscribe({ next: r => this.unreadCount$.next(r.count) });
  }

  increment(): void {
    this.unreadCount$.next(this.unreadCount$.value + 1);
  }

  markRead(id: string): Observable<void> {
    return this.http.post<void>(`${this.base}/${id}/read`, {}).pipe(
      tap(() => {
        const current = this.unreadCount$.value;
        if (current > 0) this.unreadCount$.next(current - 1);
      })
    );
  }

  markAllRead(): Observable<void> {
    return this.http.post<void>(`${this.base}/read-all`, {}).pipe(
      tap(() => this.unreadCount$.next(0))
    );
  }
}
